<template>
  <a-card class="basic-info-form-card">
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="流程模板名称" prop="name">
        <a-input v-model="form.name" placeholder="请填写流程模板名称" />
      </a-form-model-item>
      <a-form-model-item label="流程模板描述" prop="description">
        <a-textarea v-model="form.description" placeholder="请填写流程模板描述" />
      </a-form-model-item>
      <a-form-model-item label="发布评审类型" prop="release_type_options">
        <a-select v-model="form.release_type_options" mode="multiple" show-search placeholder="请选择发布评审类型">
          <a-select-option v-for="(item, index) in releaseTypes" :key="index" :value="item.value">{{ item.label }} </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import { releaseTypes } from '@/utils/dictionary';
export default {
  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      releaseTypes,
      rules: {
        name: [{ required: true, message: '流程模板名称不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      }
    }
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.basic-info-form-card {
  width: 680px;
  min-height: 560px;
  margin: 0 auto;
}
</style>
